import { Navigate } from 'react-router-dom'
import { useChallengeAccess } from '../hooks/membership/useChallengeAccess'
import { challengeTeamPath, ScreenPath } from '../navigation'
import SimplePageLayout from '../ui/layout/SimplePageLayout'
import LoadingIndicator from '../ui/util/LoadingIndicator'

/** Tab / deep-link entry for "Team": route to membership, onboarding, or challenge picker. */
export default function TeamEntryRedirect() {
  const { challengeId, teamID, hasAnyMembership, isLoading } = useChallengeAccess()

  if (isLoading) {
    return (
      <SimplePageLayout title="Team">
        <LoadingIndicator />
      </SimplePageLayout>
    )
  }

  if (teamID) {
    return <Navigate to={`${ScreenPath.team}/${teamID}`} replace />
  }

  // Free agents (and anyone without a team) go to team intro to join or create.
  if (challengeId) {
    return <Navigate to={challengeTeamPath(challengeId)} replace />
  }

  if (hasAnyMembership) {
    return <Navigate to={ScreenPath.home} replace />
  }

  return <Navigate to={ScreenPath.challenges} replace />
}
